import React, { Component, Fragment } from 'react'
import {NotificationManager} from "react-notifications";
import CardForm from 'Utils/Cards/CardForm';
import LoadMask from 'Utils/LoadMask/LoadMask';
import Modal from 'react-responsive-modal';
import EditarAulaForm from './EditarAulaForm';
import EventoModalForm from './EventoModalForm';
import { DISPONIBLE, RESERVAR } from '../../../../../utility/constants';
import moment from 'moment';
import Swal from 'sweetalert2';

export default class EditarAula extends Component {

    state = {
        modal: false,
    }

    componentWillMount() {
        // this.props.limpiar();
        this.props.leer(this.props.match.params.id);
        // this.props.obtenerHorario(this.props.match.params.id);
    };

    componentWillUnmount() {
        this.props.limpiar();
    }

    openModal = (event) => {
        this.props.preCargarEvento(event);
        this.setState({ modal: true });
    };

    closeModal = () => {
        this.setState({ modal: false });
    };

    agregarEvento = (values) => {
        this.props.agregarHorario(values);
        this.closeModal();
    }

    crear = (values) => {
        const { item } = this.props;
        const inicio = moment(values.fecha_inicio);
        const fin = moment(values.fecha_fin).endOf('month');
        const viejo_inicio = moment(item.fecha_inicio);
        const hoy = moment("00:00:00", "HH:mm:ss")

        if (fin <= inicio) {
            NotificationManager.error('La fecha de fin debe ser mayor a la fecha de inicio', 'ERROR');
        } else if ((inicio < viejo_inicio ) && (inicio < moment(viejo_inicio).startOf('month') )) {
            NotificationManager.error('La fecha de inicio no puede ser de un mes anterior', 'ERROR');
        } else if ((inicio > viejo_inicio ) && (inicio < hoy)) {
            NotificationManager.error('La fecha de inicio no puede ser menor a la actual', 'ERROR');
        } else {
            const body = {...values};
            body.fecha_inicio = inicio.format("YYYY-MM-DD");
            body.fecha_fin = fin.format("YYYY-MM-DD");
            body.fecha_maxima_pago = moment(body.fecha_maxima_pago).format("YYYY-MM-DD");
            body.serie_factura = body.serie_factura.id;

            this.props.calcularCargos(this.props.match.params.id, body);
        }
    }

    eliminarReserva = (evento) => {
        if (evento.tipo === RESERVAR) {
            Swal.fire({
                title: '¿Borrar el horario reservado?',
                text: '¡No podrá revertir esta acción!',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: '¡Sí, borrar!',
                cancelButtonText: 'No, cancelar',
                reverseButtons: true
            }).then((result) => {
                if (result.value) {
                    this.props.eliminarReserva(evento, 'EditarAulaForm');
                }
            });
        }
    }

    renderModal = () => {
        return (
            <Modal
                open={this.state.modal}
                onClose={(e) => {
                    this.closeModal();
                }}
                center
            >
                <Fragment>
                    <div className="my-4">
                        <div className="row col-12">
                            <span className="text-sm azul-claro bold">Asignación de horario</span>
                            <div className="d-flex w-100 bg-azul-claro" style={{ height: '3px' }} />
                        </div>
                        <div className="row col-12">
                            <EventoModalForm
                                cancelar={this.closeModal}
                                onSubmit={this.agregarEvento}
                            />
                        </div>
                    </div>
                </Fragment>
            </Modal>
        )
    };

    render() {
        const { crear, loader } = this.props;
        return (
            <div className="mb-4 col-12 mt-4">
                <CardForm col='12'>
                    <LoadMask loading={loader} blur>
                        <div>
                            <EditarAulaForm
                                {...this.props}
                                onSubmit={this.crear}
                                openModal={this.openModal}
                                eliminarReserva={this.eliminarReserva}
                            />
                        </div>
                    </LoadMask>
                    {this.renderModal()}
                </CardForm>
            </div>
        )
    }
}
